import { Row } from '@tanstack/react-table'

import { Log } from '@/types/logs'

export const checkIsLinkedLog = (currentLog: Log, rowIndex: number, logs: Row<Log>[]): boolean => {
    return (
        !!currentLog.eventLog &&
        logs.some((log) => log.id === currentLog.eventLog?.id) &&
        !!rowIndex &&
        (logs.at(rowIndex - 1)?.original.eventLog?.id === currentLog.eventLog?.id ||
            logs.at(rowIndex - 1)?.original?.id === currentLog.eventLog?.id)
    )
}
